import { render, staticRenderFns } from "./make_group.vue?vue&type=template&id=2acc3394&scoped=true&"
import script from "./make_group.vue?vue&type=script&lang=tsx&"
export * from "./make_group.vue?vue&type=script&lang=tsx&"
import style0 from "./make_group.vue?vue&type=style&index=0&id=2acc3394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc3394",
  null
  
)

export default component.exports